module.exports = __webpack_public_path__ + "img/customer_design_4@2x.bd7212f.jpg";